import React from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import { reactHookForm, designSystem } from '@yola/ws-ui';
import ModalWithPanels from 'src/js/modules/common/components/modal-with-panels';

const { useForm } = reactHookForm;
const { ControlGroup, InputGroupField } = designSystem;

const MODAL_WIDTH = 360;
const MODAL_HEIGHT = 'auto';
const FIELD_NAME = 'folderName';
const MAX_FOLDER_NAME_CHARS = 20;

function CreateFolderDialog({ onSubmit, onCancel, captions }) {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      [FIELD_NAME]: '',
    },
  });

  const handleDialogSubmit = (values) => {
    onSubmit(values[FIELD_NAME].trim());
  };

  return (
    <ModalWithPanels
      width={MODAL_WIDTH}
      height={MODAL_HEIGHT}
      captions={{
        title: captions.title,
        submitButton: captions.submit,
        cancelButton: captions.cancel,
      }}
      overlay="visible"
      draggable={false}
      centered
      onSubmit={handleSubmit(handleDialogSubmit)}
      onCancel={onCancel}
      onOverlayClick={onCancel}
      onPressEsc={onCancel}
    >
      <ControlGroup title={captions.folderNameLabel} required>
        <InputGroupField
          control={control}
          name={FIELD_NAME}
          rules={{
            required: i18next.t('This field is required'),
            maxLength: {
              value: MAX_FOLDER_NAME_CHARS,
              message: i18next.t(`Maximum number of characters {number}`, {
                number: MAX_FOLDER_NAME_CHARS,
              }),
            },
          }}
        />
      </ControlGroup>
    </ModalWithPanels>
  );
}

CreateFolderDialog.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  captions: PropTypes.shape({
    title: PropTypes.string.isRequired,
    folderNameLabel: PropTypes.string.isRequired,
    submit: PropTypes.string.isRequired,
    cancel: PropTypes.string.isRequired,
  }).isRequired,
};

export default CreateFolderDialog;
